/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, MobileStepper, Typography } from '@mui/material';
import { TEXT_UPCOMING_EVENT } from '../../../constants';
import SwipeableViews from 'react-swipeable-views';
import AppointmentCard from '../AppointmentCard';
import { useState } from 'react';
import { styles } from '../../../pages/registration/onboarding/intro/style';

const UpcomingEvents = ({ appointments, onAppointmentDetailsClick }: any) => {
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = appointments?.length || 0;

  const handleChangeIndex = (index: number) => {
    if (index < maxSteps && index >= 0) setActiveStep(index);
  };

  if (!(appointments && appointments?.length)) {
    return null;
  }
  return (
    <Box
      sx={{
        bgcolor: 'info.main',
        px: 3,
        pt: 5,
        pb: 3.75,
        position: 'relative',

        userSelect: 'none', // Disables text selection
      }}
      className="fw-semi-bold rounded-50"
    >
      <Typography
        variant="body1"
        sx={{ color: 'common.white', mb: 1.25 }}
        className="text-uppercase"
      >
        {TEXT_UPCOMING_EVENT}
      </Typography>

      <SwipeableViews
        enableMouseEvents
        index={activeStep}
        onChangeIndex={handleChangeIndex}
      >
        {appointments?.map((appointment: any) => (
          <AppointmentCard
            key={`appointment-${appointment.id}`}
            appointment={appointment}
            onDetailsClick={onAppointmentDetailsClick}
          />
        ))}
      </SwipeableViews>
      <MobileStepper
        sx={{
          ...styles.mobileStepper,
          justifyContent: 'center',
          marginTop: '15px',
        }}
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        className="w-100"
        nextButton={<></>}
        backButton={<></>}
      />
    </Box>
  );
};

export default UpcomingEvents;
